<template>
  <!-- <div class='wrapper '>

    <div class='login'>
    <div class="HomeHeader">
      <a-row class="top">
        <a-col :span="10">
          <img src="@assets/logo.png" @click="router.push({
            name : 'home'
          })"/>
        </a-col>
        <a-col :span="14">


        </a-col>  
      </a-row>
      
    </div>
  
    <div class='login_cont'>

          <div class='limit'>
            <img src='@assets/plane.png' class='plane'>

            <div class='login_form'>
              <h3 class='title'>账号登录</h3>
              <a-form
                :ref="ruleForm"
                :model="form"
                :rules="rules"
              > 
                <a-form-item ref="name" name="name">
                  <a-input v-model:value="form.name" placeholder="账号/手机号"/>
                </a-form-item>

                <a-form-item ref="name" name="password">
                  <a-input v-model:value="form.password" placeholder="登录密码" type='password' @pressEnter='submit'/>
                </a-form-item>
                <a-button type="primary" class='submitBtn' @click='submit' :loading='isLoginCheck'>
                    登 录
                </a-button>
                <div class='login_tips'>登录即代表您同意我们的 服务协议 和 隐私策略</div>
              </a-form>
            </div>

          </div>
      </div>
      <div class="HomeFooter">

     
        <div class="bottom">
          Copyright©2020-2020, 1-trip.com. All rights reserved. |
          ICP证：京ICP备2020036687号-1
        </div>
      </div>
    </div>


 
    
  </div> -->
  <div class="wrapper">
    <div class="bg"></div>
    <div class="login_wrapper">
      <div class="login_panel">
        <div class="text">后台管理系统</div>
        <div class="text2">Business Management System</div>
        <!-- input -->
        <div class="flex">
          <a-form :ref="ruleForm" :model="form" :rules="rules" layout="inline">
            <a-form-item ref="name" name="name">
              <a-input placeholder="请输入用户名称" v-model:value="form.name">
                <template #prefix>
                  <user-outlined type="user" />
                </template>
              </a-input>
            </a-form-item>
            <a-form-item ref="name" name="password">
              <a-input
                placeholder="请输入登录密码"
                v-model:value="form.password"
                @pressEnter="submit"
                type="password"
              >
                <template #prefix>
                  <LockOutlined />
                </template>
              </a-input>
            </a-form-item>
            <a-form-item>
              <div @click="submit">
                <RightCircleOutlined class="login_icon" />
              </div>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonApi from "@axios/common";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
import {
  UserOutlined,
  LockOutlined,
  RightCircleOutlined,
} from "@ant-design/icons-vue";

export default {
  name: "login",
  components: { UserOutlined, LockOutlined, RightCircleOutlined },
  setup() {
    const router = useRouter();
    let isLoginCheck = ref(false);
    let name = ref("");
    let password = ref("");
    const store = useStore();
    const submit = () => {
      refsItem[0].validate().then(() => {
        let params = {
          userName: form.value.name,
          password: form.value.password,
        };
        isLoginCheck.value = true;
        commonApi
          .login(params)
          .then((res) => {
            isLoginCheck.value = false;
            store.commit("setToken", res.token);
            store.commit("setUserName", res.username);
            store.commit("sePermissions", res.permissions);
            store.commit("seRoles", res.roles);

            if(res.user.status === "1"){
              message.error("该用户已禁用")
              console.log("该用户已禁用")
              return;
            }

            router.replace({
              path: "/",
            });


          })
          .catch(() => {
            isLoginCheck.value = false;
          });
      });
    };

    let form = ref({
      name: "",
      password: "",
    });

    let refsItem = [];

    const ruleForm = (el) => {
      refsItem.push(el);
    };

    return {
      form,
      ruleForm,
      submit,
      isLoginCheck,
      name,
      password,
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.login_icon {
  color: #fff;
  font-size: 40px;
  margin-top: 15px;
  margin-left: 10px;
}
.bg {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  -ms-overflow-x: hidden;
  overflow-x: hidden;
  -ms-overflow-y: hidden;
  overflow-y: hidden;
  background-color: rgba(26, 188, 156, 1);
  background-image: url(~@/assets/bg_plane.jpg);
  background-position: right top;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: cover;
  background-origin: border-box;
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.login_wrapper {
  position: fixed;
  left: 50%;
  margin-left: -50%;
  top: 50%;
  margin-top: -150px;
  width: 1100px;
  height: 300px;
}
.login_panel {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 300px;
  -ms-overflow-x: hidden;
  overflow-x: hidden;
  -ms-overflow-y: hidden;
  overflow-y: hidden;
  background-color: rgba(0, 0, 0, 0.498039215686275);
  background-image: none;
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: center;
}
.text {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  text-decoration: none;
  font-size: 48px;
  padding: 2px 2px 2px 2px;
  color: #fff;
}
.text2 {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  text-decoration: none;
  font-size: 36px;
  color: #fff;
}

.flex {
  display: flex;
  .ant-input-affix-wrapper {
    width: 230px;
    /deep/ .ant-input-prefix {
      left: 27px;
    }
  }
  justify-content: center;
  /deep/ .ant-input {
    margin: 20px;
    width: 200px;
  }
}
//old css
.wrapper {
  height: 100vh;
}
.login {
  height: 100%;
  text-align: left !important;
}
.code_content {
  position: absolute;
  left: 30px;
  top: 40px;
  display: flex;
  justify-content: flex-start;
  & > div {
    margin-left: 15px;

    font-size: 22px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #ffffff;
    line-height: 30px;
    letter-spacing: 1px;
  }

  img {
    width: 100px;
    height: 100px;
  }
}
.plane {
  width: 882px;
  position: absolute;
  left: -50px;
  top: 202px;
}
.submitBtn {
  background: #ffab00;
  border-color: #ffab00;
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 40px;
  margin-top: 15px;
}
.login_tips {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #bbbbbb;
  margin-top: 13px;
  margin-bottom: 80px;
}
.login {
  display: flex;
  flex-direction: column;
}
.login_cont {
  background: #409eff;
  min-height: 580px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .limit {
    flex: 1;
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .login_form {
    background: #fff;
    border-radius: 4px;
    width: 380px;
    padding: 28px 30px;
    position: absolute;
    right: 0;
    top: 40px;
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin-bottom: 22px;
    }
  }
}

.limit {
  ::v-deep(.ant-input) {
    height: 40px;
  }

  ::v-deep(.ant-form-item) {
    margin-bottom: 17px;
  }
}

.icon {
  margin-left: 10px;
}
.top {
  width: 1200px;
  height: 90px;
  line-height: 90px;
  margin: 0 auto;
  .ant-col-10 {
    text-align: left;
    img {
      height: 68px;
      cursor: pointer;
    }
  }
  .ant-col-14 {
    text-align: right;
    color: #6d7278;
    .action {
      color: #0d6dbf;
      margin: 0 4px;
    }
    span {
      color: #0d6dbf;
      margin-left: 6px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.nav {
  width: 100%;
  height: 40px;
  background: #409eff;
  color: #ffffff;
  .main {
    width: 1200px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    .ant-col-14 {
      text-align: left;
      span {
        display: inline-block;
        width: 65px;
        height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .train {
        background: #0d6dbf;
        position: relative;
        span {
          display: block;
          width: 0;
          height: 0;
          border: 7.5px solid #fff;
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -7.5px;
          border-right: 7.5px solid transparent;
          border-top: 7.5px solid transparent;
          border-left: 7.5px solid transparent;
        }
      }
    }
    .ant-col-10 {
      text-align: right;
      span {
        cursor: pointer;
      }
    }
  }
}

.banner_text {
  font-size: 22px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #0d6dbf;
  line-height: 30px;
  letter-spacing: 1px;
}
.banner {
  width: 1200px;
  height: 226px;
  margin: 0 auto;
  background: linear-gradient(169deg, #f6fbff 0%, #e5f5ff 100%);
  border-radius: 5px;
  position: relative;
  padding: 30px 34px;
  .img_content {
    position: absolute;
    right: 50px;
    bottom: 0px;
    .phone {
      width: 170px;
    }
    .code {
      width: 140px;
      position: absolute;
      right: 17px;
      bottom: 45px;
    }
  }
}
.main {
  width: 1200px;
  height: 44px;
  margin: 72px auto 53px;
  background: #ffffff;
  .ant-col {
    text-align: left;
    img {
      width: 45px;
      margin-right: 12px;
      vertical-align: bottom;
    }
    div {
      display: inline-block;
      margin-left: 15px;
    }
  }
}
.bottom {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
  background: #f8f8f8;
  font-size: 14px;
  color: #979797;
}
</style>
